import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import PageSizeDropdown from '../../elements/PageSizeDropdown';
import SearchStats from '../../elements/SearchStats';
import SortByDropdown from '../../elements/SortByDropdown';
import ViewToggleButtons from '../../elements/ViewToggleButtons';
import { LinkSmall } from '@styled';

import { getAlgoliaIndexNameGlobal } from '@general/helpers/search.helpers';
import { SearchTypeContext } from '../../../context/searchTypeContext';
import { PageSizeContext, SortByContext, AttendeeModeContext } from '../../../context/searchContext';
import useEventAttendeePdf from '../../../hooks/useEventAttendeePdf';
import AttendeePdfAccessModal from '../../../../../attendee-pdf-access/js/components/AttendeePdfAccessModal';

const SearchOptionsDesktop = ({ displayMap = false, onPageSizeChange, onSortByChange, onViewTypeChange }) => {
    const [searchType] = useContext(SearchTypeContext);
    const [sortBy] = useContext(SortByContext);
    const [pageSize] = useContext(PageSizeContext);
    const indexName = getAlgoliaIndexNameGlobal(searchType.index);

    const attendeeModeContext = useContext(AttendeeModeContext);
    const { eventAttendeePdf } = useEventAttendeePdf(attendeeModeContext?.event);

    const [modalAttached, setModalAttached] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const openModal = () => {
        setIsModalOpen(true);
        <AttendeePdfAccessModal onClose={closeModal} eventLink={eventAttendeePdf} />
    };

    useEffect(() => {
        if (eventAttendeePdf && !modalAttached) {
            const attendeePdfLink = document.getElementById('attendee-pdf-download');
            if (attendeePdfLink) {
                attendeePdfLink.addEventListener('click', handleAttendeePdfDownload);
                setModalAttached(true);
            }
        }

        return () => {
            const attendeePdfLink = document.getElementById('attendee-pdf-download');
            if (attendeePdfLink) {
                attendeePdfLink.removeEventListener('click', handleAttendeePdfDownload);
            }
        };
    }, [eventAttendeePdf, modalAttached]);

    const handleAttendeePdfDownload = (event) => {
        event.preventDefault();
        openModal();
    };

    return (
        <ul className="nav nav-pills listing-filters d-flex justify-content-start">
            <li className="align-self-center mr-auto">
                <SearchStats />
            </li>

            {eventAttendeePdf && (
                <li className="align-self-center mr-md-5 mt-0.25rem">
                    <LinkSmall href={eventAttendeePdf} className="text-sm" id="attendee-pdf-download" target="_blank">
                        Attendee List (pdf)
                    </LinkSmall>
                </li>
            )}

            <li className="nav-item dropdown d-inline-block my-md-auto mr-md-5 align-self-center">
                <SortByDropdown
                    items={[]}
                    defaultRefinement={`${indexName}${sortBy ? sortBy.indexSuffix : ''}`}
                    onSortByChange={onSortByChange}
                />
            </li>

            {/* <li className="nav-item dropdown d-inline-block my-md-auto mr-md-5 align-self-center">
                <PageSizeDropdown
                    items={[]}
                    defaultRefinement={pageSize.hitsPerPage}
                    onPageSizeChange={onPageSizeChange}
                />
            </li> */}

            <ViewToggleButtons displayMap={displayMap} onViewTypeChange={onViewTypeChange} />
        </ul>
    );
};

SearchOptionsDesktop.propTypes = {
    displayMap: PropTypes.bool,
    onPageSizeChange: PropTypes.func.isRequired,
    onSortByChange: PropTypes.func.isRequired,
    onViewTypeChange: PropTypes.func.isRequired,
};

export default SearchOptionsDesktop;
